import './AnimatedLine.css'

interface IAnimatedLineProps {
    width: number
    animate: boolean;
    onAnimationEnd: () => void;
    animationKey: string
    paused: boolean
}

export default function AnimatedLine(props: IAnimatedLineProps) {
    return <div className="Animated_line_container" style={{width: `${props.width}px`}}>
        <div className="Animated_line_background"/>
        {props.animate &&
        <div className="Animated_line_foreground" style={{animationPlayState: `${props.paused ? "paused" : "running"}`}} key={props.animationKey} onAnimationEnd={props.onAnimationEnd}/>}
    </div>
}